<template>
    <div>
        <app-header></app-header>
        <sidebar></sidebar>
        <div class="main-area" :class="{large_main_area:large_main_area}">
            <timeline></timeline>
            <div class="section">
                <router-view></router-view>
            </div>
        </div>
        
    </div>
</template>

<script>
import Header from '../components/Header.vue'
import Sidebar from '../components/Sidebar.vue'
import Timeline from '../components/Timeline.vue'
export default {
    components: { 
        'app-header':Header,
        'sidebar':Sidebar ,
        'timeline':Timeline    
    },
    data() {
        return{
            large_main_area:false,
        }
    },
    methods: {
        toggle_main_area(large){
            if(large === true) this.large_main_area = true
            else this.large_main_area = false
            
        }
    }
}
</script>

<style scoped>
.main-area{
    width: calc(100% - 5rem);
    height: calc(100vh - 5rem);
    transform: translateX(5rem);
    /* overflow:hidden; */
    transition: .3s all;
}
.large_main_area{
    transform: translateX(0);
    width: 100%;
}
.section{
    width: 100%;
    height: calc(100% -  5rem);
}
</style>


// WEBPACK FOOTER //
// src/views/Dashboard.vue